import checksum from "./checksum";

const validateNRIC = (ic, inputType) => {
    ic = ic.trim().toUpperCase();

    if(inputType === "nric"){
        if (!/^[S|T]\d{7}[J|Z|I|H|G|F|E|D|C|B|A]$/.test(ic)) {
            return 0;
        }
    }else{
        if (!/^[F|G|M]\d{7}[X|W|U|T|R|Q|P|N|M|L|K]$/.test(ic)) {
            return 0;
        }
    }

    const prefix = ic[0];
    const number = ic.slice(1, -1);
    const suffix = ic.slice(-1);

    return suffix === checksum(prefix, number) ? 1 : -1;
};

export default validateNRIC;